import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { MethodOverview } from './components/MethodOverview';
import { MaterialPreview } from './components/MaterialPreview';
import { Pricing } from './components/Pricing';
import { UpgradeComparison } from './components/UpgradeComparison';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center" data-id="element-0">
    <p className="text-xl md:text-3xl font-serif italic text-brand-text/80 leading-relaxed" data-id="element-1">
      La próxima semana puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-rose/30 selection:text-brand-rose bg-brand-surface" data-id="element-2">
      <UrgencyBanner data-id="element-3" />
      <Hero data-id="element-4" />
      <InitialTestimonials data-id="element-5" />
      <PainPoints data-id="element-6" />
      <MethodOverview data-id="element-7" />
      <Pricing data-id="element-8" />
      <UpgradeComparison data-id="element-9" />
      <MaterialPreview data-id="element-10" />
      <MoreTestimonials data-id="element-11" />
      <Guarantee data-id="element-12" />
      <FAQ data-id="element-13" />
      <CostComparison data-id="element-14" />
      <TransitionPhrase data-id="element-15" />
      <EmotionalClose data-id="element-16" />
      <Footer data-id="element-17" />
      <FloatingNotification data-id="element-18" />
    </div>;
}